import { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
} from "@mui/material";

/* Label above input */
const Label = ({ text, required = false }) => (
  <Typography fontSize="14px" fontWeight={600} mb={0.8}>
    {text}
    {required && <span style={{ color: "red" }}> *</span>}
  </Typography>
);

/* Shared input styles (same as Contact form) */
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    height: "44px",
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "#cfcfcf",
    },
    "&:hover fieldset": {
      borderColor: "#b5b5b5",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#cfcfcf",
      borderWidth: "1px",
    },
  },
};

const initialState = {
  schoolName: "",
  email: "",
  issue: "",
};

export default function SupportForm() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const validate = () => {
    const newErrors = {};

    if (!form.schoolName.trim())
      newErrors.schoolName = "School name is required";

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)
    ) {
      newErrors.email = "Enter a valid email";
    }

    if (!form.issue.trim())
      newErrors.issue = "Please describe your issue";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      console.log("✅ Support Request:", form);

      // Reset form
      setForm(initialState);
      setErrors({});

      alert("Support request submitted successfully!");
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", p: 2 }}>
      {/* HEADING */}
      <Typography variant="h3" color="#0a5f7f" mb={6}>
        Support
      </Typography>

      <Typography fontSize="15px" mb={4}>
        Please fill out the form below and our support team will get back to you.
      </Typography>

      {/* SCHOOL NAME */}
      <Box mb={3}>
        <Label text="School Name" required />
        <TextField
          fullWidth
          sx={inputSx}
          value={form.schoolName}
          onChange={handleChange("schoolName")}
          error={!!errors.schoolName}
          helperText={errors.schoolName}
        />
      </Box>

      {/* EMAIL */}
      <Box mb={3}>
        <Label text="Email Address" required />
        <TextField
          fullWidth
          sx={inputSx}
          value={form.email}
          onChange={handleChange("email")}
          error={!!errors.email}
          helperText={errors.email}
        />
      </Box>

      {/* ISSUE */}
      <Box mb={4}>
        <Label text="Issue / Message" required />
        <TextField
          fullWidth
          multiline
          rows={4}
          sx={{
            ...inputSx,
            "& .MuiOutlinedInput-root": {
              height: "auto",
            },
          }}
          value={form.issue}
          onChange={handleChange("issue")}
          error={!!errors.issue}
          helperText={errors.issue}
        />
      </Box>

      {/* SUBMIT */}
      <Button
        variant="contained"
        onClick={handleSubmit}
        sx={{
          backgroundColor: "#e8511f",
          color: "white",
          fontWeight: "bold",
          px: 5,
          py: 1.3,
          borderRadius: "6px",
          "&:hover": { backgroundColor: "#e8511f" },
        }}
      >
        SUBMIT
      </Button>
    </Box>
  );
}
